import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { JobPostAdapters } from '../adapters';
import { IGetJobPostingsPayload, IJobPostApiResponse } from '../types';

export const getJobPostings = async (
  payload: IGetJobPostingsPayload,
): Promise<IJobPostApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IJobPostApiResponse>('/offer-service/offices/postings', {
    headers,
    params: JobPostAdapters.toGetJobPostingsApiQueryParams(payload),
  });

  return response.data;
};
